namespace app.support {

    export class StfHeaderController {

        private localBreadcrumbs;
        public tentouExecutarTarefaSemAssumir = false;
        public task: app.tarefas.minhasTarefas.ITask;
		public assigneeName;
		
        /**  @ngInject */
        constructor(private $scope: StfHeaderScope, 
                private stfBreadcrumbsService: StfBreadcrumbsService,
                private $stateParams: ng.ui.IStateParamsService,
                private minhasTarefasService: app.tarefas.minhasTarefas.MinhasTarefasService, 
                private messagesService: app.support.messaging.MessagesService, 
                private authService: app.autenticacao.AuthService, 
                private $mdDialog: ng.material.IDialogService,
                private $state: ng.ui.IStateService,
                $timeout: ng.ITimeoutService) {
            
            if (this.$scope.path) {
                this.localBreadcrumbs = this.stfBreadcrumbsService.generateBreadcrumbFromLocalPath(this.$scope.path);
            }

            $scope.$on("tentouExecutarTarefaSemAssumir", () => {
                this.tentouExecutarTarefaSemAssumir = true;
                $timeout(() => {
                    this.tentouExecutarTarefaSemAssumir = false;
                }, 1000);
                
            });
            this.task = this.$stateParams["task"];
			this.loadAssigneeName();
			
            $scope.$on('task:assigned', (event: ng.IAngularEvent, notification: app.notification.INotification) => {
                let task : app.tarefas.minhasTarefas.ITask = notification.content;
            
                if (this.task && this.task.id == task.id) {
                    this.task.assignee = task.assignee;
                    this.task.selfAssigned = (this.task.assignee === this.authService.getUserLogin());
                    
                    if (!this.task.selfAssigned && !!task.assignee && !this.isAlertDisabled()) {
						this.minhasTarefasService.getNomesUsuarios([this.task.assignee]).then(resultado => {
							for (const [key, value] of Object.entries(resultado)) {								
								this.assigneeName = value;
								this.messagesService.warn(`Atenção! Esta tarefa foi assumida por "${this.assigneeName}".`);
							}
						});                        
                    }
                }
            });
            
            $scope.$on('task:completed', (event: ng.IAngularEvent, notification: app.notification.INotification) => {
                let task : app.tarefas.minhasTarefas.ITask = notification.content;
            
                if (this.task && this.task.id == task.id) {			        
                    this.authService.getUser().then((user) => {
                        this.task.selfAssigned = (user.login == this.task.assignee);
                        
                        if (!this.task.selfAssigned && !this.isAlertDisabled()) {
							this.minhasTarefasService.getNomesUsuarios([this.task.assignee]).then(resultado => {
								for (const [key, value] of Object.entries(resultado)) {								
									this.assigneeName = value;
									let title = "Tarefa finalizada!";                            
									let text = `Esta tarefa já foi realizada por ${this.assigneeName}.`;
									this.alertAndCloseTask(title, text);
								}
							});
                        }
                    });
                }
            });
            
            $scope.$on('task:canceled', (event: ng.IAngularEvent, notification: app.notification.INotification) => {
                let task : app.tarefas.minhasTarefas.ITask = notification.content;
            
                if (this.task && this.task.id == task.id) {
                    this.authService.getUser().then((user) => {
                        this.task.selfAssigned = (user.login == this.task.assignee);
                        
                        if (!this.task.selfAssigned && !this.isAlertDisabled()) {
							this.minhasTarefasService.getNomesUsuarios([this.task.assignee]).then(resultado => {
								for (const [key, value] of Object.entries(resultado)) {								
									this.assigneeName = value;
									let title = "Tarefa cancelada!";
									let text = `Esta tarefa foi cancelada por ${this.assigneeName}.`;
									this.alertAndCloseTask(title, text);
								}
							});
                        }
                    });                    
                }
            });			
        }

        public hasBreadcrumbs(): boolean {
            return !this.$scope.layoutOnly &&
                (this.localBreadcrumbs || 
                        (this.stfBreadcrumbsService.breadcrumbs != this.stfBreadcrumbsService.EMPTY_BREADCRUMB));
        }

        public breadcrumbs(): any {
            if (this.localBreadcrumbs) {
                return this.localBreadcrumbs;
            } else {
                return this.stfBreadcrumbsService.breadcrumbs
            }
        }
        
        public isTarefaAssumida(): boolean {
            return this.task && this.task.selfAssigned;
        }

        public assumir(): void {
            this.minhasTarefasService.assumeTask(this.task).then((task) => {
                this.task = task;
				this.loadAssigneeName();
                this.messagesService.warn("Tarefa assumida com sucesso.");
            });
        }
        
        private alertAndCloseTask(title: string, text: string): void {
            this.task.selfAssigned = false;
            this.$mdDialog.show(
                this.$mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(false)
                  .hasBackdrop(true)
                  .title(title)
                  .textContent(text)
                  .ok('OK')
              ).then(() => {
                  this.$state.go("app.tarefas.minhas-tarefas");
              });
        }

        private isAlertDisabled(): boolean {
            return !!this.$scope.disableAlert && this.$scope.disableAlert;
        }
				
		private loadAssigneeName(): void {
			if (this.task && this.task.assignee) {
				this.minhasTarefasService.getNomesUsuarios([this.task.assignee]).then(resultado => {
					for (const [key, value] of Object.entries(resultado)) {
						this.assigneeName = value;
					}
				});
			}
		}
    }

}